export default __webpack_public_path__ + "static/media/CP_Header.5edd18ca.png";